export default {"src":"/_next/static/media/deco_checkout_venmo.853f29f7.svg","height":11,"width":55,"blurWidth":0,"blurHeight":0};